import { Component, OnInit } from '@angular/core';
import { AttendanceService } from 'src/app/services/attendance/attendance.service';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import * as moment from 'moment'

@Component({
  selector: 'app-consolidated-daily-attendance',
  templateUrl: './consolidated-daily-attendance.component.html',
  styleUrls: ['./consolidated-daily-attendance.component.css']
})
export class ConsolidatedDailyAttendanceComponent implements OnInit {


  constructor(private attendanceservice: AttendanceService, private lookupservice: LookupService,
    public globalHelper: GlobalHelper, private spinnerService: Ng4LoadingSpinnerService) { }

  StudentAttendanceList:any;
  CurrentStatusHeader:any;
  Submitted: boolean = false;
  TotalStudents:number=0;
  TotalPresent:number=0;
  TotalLeave:number=0;
  TotalAbsent:number=0;

  StudentDailyAttendancetModel = {
    AttendanceDate:  moment(new Date()).format("DD-MMM-YYYY"),
  }

  Clear() {
    this.StudentDailyAttendancetModel.AttendanceDate = moment(new Date()).format("DD-MMM-YYYY");
    this.Submitted = false;
    this.StudentAttendanceList=[];
  }

  GetConsolidatedDailyStudentAttendance(valid) {
   
    if (valid==undefined || valid) {
       this.spinnerService.show();     
        this.attendanceservice.GetConsolidatedDailyStudentAttendance(moment(new Date(this.StudentDailyAttendancetModel.AttendanceDate)).format("DD-MMM-YYYY")).subscribe((data: any) => {
            this.StudentAttendanceList = data.StudentAttendanceList;
            if (this.StudentAttendanceList != null) {
                var TotalStudents = 0;
                var TotalPresent = 0;
                var TotalLeave = 0;
                var TotalAbsent = 0;
                for (var i = 0; i < this.StudentAttendanceList.length; i++) {
                    TotalStudents = TotalStudents + this.StudentAttendanceList[i].Total;
                    TotalPresent = TotalPresent + this.StudentAttendanceList[i].Present;
                    TotalLeave = TotalLeave + this.StudentAttendanceList[i].Leaves;
                    TotalAbsent = TotalAbsent + this.StudentAttendanceList[i].Absent;
                }
                this.TotalStudents = TotalStudents;
                this.TotalPresent = TotalPresent;
                this.TotalLeave = TotalLeave;
                this.TotalAbsent = TotalAbsent;
            }
            this.spinnerService.hide();
            this.globalHelper.CheckActionStatus(data);
        });
    }


};
  

  ngOnInit() {    
   
  }
  
}


